import { Paper } from '@material-ui/core'
import { PaperProps } from '@material-ui/core/Paper'
import { isNot } from 'typescript-styled-is'
import styled from '../../../theme'

type Type = PaperProps & IRoomLimitExceededModalWrapper
const RoomLimitExceededModalWrapper = styled(Paper)<Type>`
  border: none;
  outline: none;
  min-width: 20vw;
  max-height: 100%;
  ${isNot('overflow')`
    overflow-y: auto;
    overflow-x: hidden;
  `}
`

export default RoomLimitExceededModalWrapper

export interface IRoomLimitExceededModalWrapper {
  overflow?: boolean
}
